import { render, staticRenderFns } from "./SpeakerList.vue?vue&type=template&id=b71676de"
import script from "./SpeakerList.vue?vue&type=script&lang=js"
export * from "./SpeakerList.vue?vue&type=script&lang=js"
import style0 from "./SpeakerList.vue?vue&type=style&index=0&id=b71676de&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports